import React, { PureComponent } from 'react';

import './Errors.css';
import PageErrorX from './PageErrorX';

class AccessForbiden extends PureComponent {
  render() {
    return (
      <PageErrorX
        variant="404"
        title="Oops! Not Found"
        message="Lo sentimos, la página que buscas no se encuentra o ha cambiado de nombre."
      />
    )
  }
}

export default AccessForbiden;